import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import ProductDataFilter from "../../../components/product-data-filter/product-data-filter";
import GenericDataChart from "../../../GenericPageElements/GenericDataChart";
import GenericPageContainer from "../../../GenericPageElements/GenericPageContainer";
import GenericProductFilterContainer from "../../../GenericPageElements/GenericProductFilterContainer";
import endpoints from "../../../helpers/endpoints";
import hasPermission from '../../../helpers/permissions';
import request from "../../../helpers/request";
import S3Modal from "../../../components/s3Modal/S3Modal";
import session from "../../../stores/session";
import GenericDataRow from "../../../GenericPageElements/GenericDataRow";
import { view } from "@risingstack/react-easy-state";
import { Link } from "react-router-dom";
import BulkBuy from '../../../components/cot-alert-bulk-buy/bulkBuy';
import BulkAllocate from '../../../components/cot-alert-bulk-allocate/bulkAllocate';
import Text from 'recharts/lib/component/Text';
import './PriorityCleansing.scss';

const CustomizedAxisTickMultiLine = ({x, y, payload}) => {
    return (
       <Text x={x} y={y} width={60} textAnchor="middle" verticalAnchor="start" className='scale-text' >{payload.value}</Text>
    )
};

export default view(function PriorityCleansingSummary() {
  const [filters, setFilters] = useState({});
  const [selectedGroupBy, setSelectectGroupBy] = useState("Assigned_To");
  const [data, setData] = useState(null);
  const [dates, setDates] = useState([]);
  const [date, setDate] = useState(null);
  const [S3Model, setS3Model] = useState(null);
  const [bulkModel, setBulkModel] = useState('')

  useEffect(() => {
    console.log(S3Model)
  }, [S3Model])
  
  const applyFilter = (column, value) => {
    setFilters((current) => {
      return {
        ...current,
        [column]: value,
      };
    });
  };

  useEffect(() => {
    request(true)
      .get(endpoints.PRIORITY_CLEANSING_DATES)
      .then((e) => {
        setDates(e.data.dates);
        if (e.data.dates.length > 0) setDate("All_Refreshes");
      });
  }, []);

  useEffect(() => {
    // if (!date) return;
    request(true)
      .get(endpoints.PRIORITY_CLEANSING_DATA, {
        doesCancel: true,
        params: {
          date: date,
          filter: filters,
          group: selectedGroupBy,
        },
      })
      .then((e) => {
        setData(e.data);
      });
  }, [filters, selectedGroupBy, date]);

  return [
    <GenericPageContainer
      title="Priority Cleansing - Summary"
      titleIconClass={"fak fa-id-business-icon fa-2x colour-primary"}
      containerWidth={"92vw"}
      titleRight={
        <div>
          {hasPermission('PRIORITY_CLEANSING', 'DOWNLOAD') ? (
              <button className="navigate" onClick={() => setS3Model("download")}>
                  Download Return File
              </button>
          ) : null}
          {hasPermission('PRIORITY_CLEANSING', 'UPLOAD') ? (
            <button className="navigate" onClick={() => setS3Model("upload_spids")}>
              Upload SPIDs
            </button>
          ) : null}
          {hasPermission('PRIORITY_CLEANSING', 'UPLOAD') ? (
            <button className="navigate" onClick={() => setS3Model("upload_meters")}>
              Upload Meters
            </button>
          ) : null}
          { (hasPermission('PRIORITY_CLEANSING', 'WORKFLOW')) ?
            <Link className="navigate" to="/portal/priority-cleansing/premises-workflow">
              Premises Workflow
            </Link>
          : null }
          { (hasPermission('PRIORITY_CLEANSING', 'WORKFLOW')) ?
            <Link className="navigate" to="/portal/priority-cleansing/meters-workflow">
              Meters Workflow
            </Link>
          : null }
        </div>
      }
    >
      <div style={{maxWidth: '20vw', marginBottom: 15}}>
      <GenericDataRow title={"File Date"} contentColour={"white"}>
        <select
          onChange={(_) => setDate(_.target.value)}
          value={date}
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            backgroundColor: "white",
            paddingLeft: "10px",
          }}
        >
          <option key={"All_Refreshes"} value={"All_Refreshes"}>All Refreshes</option>
          {dates.map((item) => {
            return (
              <option key={item.raw} value={item.raw}>
                {item.pretty}
              </option>
            );
          })}
        </select>
      </GenericDataRow>
      </div>
      <div className='PC'>
        <GenericDataChart
          dataReady={!!data}
          data={data}
          selectedGroupBy={selectedGroupBy}
          setSelectectGroupBy={setSelectectGroupBy}
          groupingsEndpoint={endpoints.PRIORITY_CLEANSING_GROUPINGS}
          sizes={{chart: 600, chartContainer: 625, chartXAxisFontSize: 12, wrapperStyle: { paddingTop: '40px' }}}
          xAxisProps={{interval: 0}}
          customBarTick={CustomizedAxisTickMultiLine}
          overrideTableHeader={"Summary"}
          displayModeInitial="table"
          tableClasses="smaller-text"

        />
        <GenericProductFilterContainer clearFilters={() => setFilters({})} style={{ fontSize: 'smaller' }}>
          <ProductDataFilter
            filterState={filters}
            applyFilter={applyFilter}
            dataFilterEndpoint={endpoints.PRIORITY_CLEANSING_FILTERS}
          />
          <div className='grid grid-columns-2 grid-gap-5 mta'>
              { (hasPermission('PRIORITY_CLEANSING', 'ALLOCATE')) ?
                <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('allocate_premises')}>
                    Allocate Premises
                </button>
              : '' }
              { (hasPermission('PRIORITY_CLEANSING', 'ALLOCATE')) ?
                <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('allocate_meters')}>
                    Allocate Meters
                </button>
              : '' }
              { (hasPermission('PRIORITY_CLEANSING', 'UNALLOCATE')) ?
                <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('unallocate_premises')}>
                    Unallocate Premises
                </button>
              : '' }
              { (hasPermission('PRIORITY_CLEANSING', 'UNALLOCATE')) ?
                <button className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('unallocate_meters')}>
                    Unallocate Meters
                </button>
              : '' }
              { (hasPermission('PRIORITY_CLEANSING', 'BULK-BUY')) ?
                <button style={{  gridColumn: 'span 2' }} className="button bulk-buy-button compact smaller-text" onClick={() => setBulkModel('purchase')}>
                  Create Download File
                </button>
              : '' }
          </div>
        </GenericProductFilterContainer>
      </div>
    </GenericPageContainer>,
    <S3Modal
      closeModal={() => setS3Model(null)}
      modalMode={S3Model}
      showModal={S3Model === "download"}
      listingUrl={endpoints.PRIORITY_CLEANSING_FILES}
      uploadUrl={endpoints.PRIORITY_CLEANSING_FILES}
    />,
    <S3Modal
      closeModal={() => setS3Model(null)}
      modalMode={S3Model}
      showModal={S3Model === "upload_spids"}
      titleOverride={"Upload Core SPID list"}
      listingUrl={endpoints.PRIORITY_CLEANSING_FILES}
      uploadUrl={endpoints.PRIORITY_CLEANSING_UPLOAD_SPIDS}
      successMessageOverride={"Your file is being processed. You will receive an email once complete."}
    />,
    <S3Modal
      closeModal={() => setS3Model(null)}
      modalMode={S3Model}
      titleOverride={"Upload Meters"}
      showModal={S3Model === "upload_meters"}
      listingUrl={endpoints.PRIORITY_CLEANSING_FILES}
      uploadUrl={endpoints.PRIORITY_CLEANSING_UPLOAD_METERS}
      successMessageOverride={"Your file is being processed. You will receive an email once complete."}
    />,
    <BulkBuy 
      SentenceFirst={({count}) => <>The selected data set includes {count} SPIDs to be downloaded. Press the 'Create File' button to create the download file and you will receive an email notification once this is available. Alternatively press the 'Cancel' button to go back to the summary screen.</>}
      SentenceSecond={() => <></>}
      purchaseLabel="Download Limit:"
      buyButtonText="Create File"
      completeOnFirstStep={true} 
      workflowUsersEndpoint={endpoints.PRIORITY_CLEANSING_WF_USERS} 
      bulkEndpoint={endpoints.PRIORITY_CLEANSING_BULK_BASE} 
      modalIsOpen={bulkModel === 'purchase'} 
      closeModal={() => setBulkModel('')} 
      filters={filters} 
      date={date} 
    />,
    <BulkAllocate 
    workflowUsersEndpoint={endpoints.PRIORITY_CLEANSING_WF_USERS + '?type=premises'} 
    bulkEndpoint={endpoints.PRIORITY_CLEANSING_BULK_SPIDS} 
    unallocateEndpoint={endpoints.PRIORITY_CLEANSING_UNALLOCATE_SPIDS} 
    modalIsOpen={bulkModel === 'allocate_premises' || bulkModel === "unallocate_premises"} 
    mode={bulkModel === "unallocate_premises" ? "unallocate" : "allocate_premises"}
    closeModal={() => setBulkModel('')} 
    filters={filters} 
    date={date} />,
    <BulkAllocate 
    workflowUsersEndpoint={endpoints.PRIORITY_CLEANSING_WF_USERS + '?type=meters'} 
    bulkEndpoint={endpoints.PRIORITY_CLEANSING_BULK_METERS} 
    urlParams={{test: "yes"}} 
    unallocateEndpoint={endpoints.PRIORITY_CLEANSING_UNALLOCATE_METERS} 
    modalIsOpen={bulkModel === 'allocate_meters' || bulkModel === "unallocate_meters"} 
    mode={bulkModel === "unallocate_meters" ? "unallocate" : "allocate_meters"}
    closeModal={() => setBulkModel('')} 
    filters={filters} 
    date={date} />,
  ];
})
